import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {CommonInputComponent} from '../common-input/common-input.component';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

interface SelectOption {
  value: any;
  displayValue: any;
}

@Component({
  selector: 'app-common-select',
  templateUrl: './common-select.component.html',
  styleUrls: ['./common-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CommonSelectComponent),
      multi: true
    }
  ]
})
export class CommonSelectComponent extends CommonInputComponent implements OnInit, ControlValueAccessor {

  @Input() options: SelectOption[];
  @Input() placeholder: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.actualValue = this.ngModelObject;
    if (!this.placeholder) {
      this.placeholder = this.label;
    }
  }

  ngOnChanges(): void {
    this.placeholder = this.label;
  }

}
